import { useEffect, useState } from 'react'

/** Shared clock for open/closed filtering — simple setInterval like lobby-huay. */
export function useBerThongNowMs(intervalMs = 1000): number {
  const [nowMs, setNowMs] = useState(() => Date.now())

  useEffect(() => {
    const tick = () => setNowMs(Date.now())
    tick()
    const id = window.setInterval(tick, intervalMs)
    const onVisibility = () => {
      if (!document.hidden) tick()
    }
    document.addEventListener('visibilitychange', onVisibility)
    return () => {
      window.clearInterval(id)
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [intervalMs])

  return nowMs
}
